import { render, staticRenderFns } from "./cooperative-partner.vue?vue&type=template&id=67436cbd&"
import script from "./cooperative-partner.vue?vue&type=script&lang=js&"
export * from "./cooperative-partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports